import React from 'react'

const ButtonCon = () => {
    return (
        <button className="btn">SUBSCRIBE</button>
    );
}

export default ButtonCon;